import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { internalSelectors } from 'state/internal.selectors';
import { isValidType } from './helpers';

const selfSelector = (state: RootState) => state.myAuctions;
const pathnameSelector = (state: RootState) => state.router.location?.pathname || '';

const auctionsBidDataSelector = (state: RootState) => state.auctionsBids.auctionsBidData;
const auctionsRapDataSelector = (state: RootState) => state.auctionsBids.auctionsRapData;

const pagerSelector = createDraftSafeSelector(
  selfSelector,
  (myAuctionsState) => myAuctionsState.pager,
);

const myAuctionsRawListSelector = createDraftSafeSelector(
  selfSelector,
  (myAuctionsState) => myAuctionsState.rawAuctionsList,
);

const myAuctionsListSelector = createDraftSafeSelector(
  selfSelector,
  internalSelectors.auctionsWatchSelector,
  auctionsRapDataSelector,
  (state: RootState) => state.attachments.attachments,
  (myAuctionsState, watch, rapMap, attachmentsMap) => {
    const { auctionsList } = myAuctionsState;

    return auctionsList.map((item: MyAuctionsTypes.MyAuctionType) => {
      const rapPrice = rapMap[item.auction_id];
      const attachments = attachmentsMap[item.auction_id];

      return {
        ...item,
        rapPrice,
        attachments,
        watch: watch[item.auction_id],
      };
    });
  },
);

const myAuctionsQuickFiltersForTypeSelector = createDraftSafeSelector(
  selfSelector,
  pathnameSelector,
  (state, pathname) => {
    const type = pathname.replace('/auctions/', '') as MyAuctionsTypes.MyAuctionsTypes;
    if (!isValidType(type) || !state.quickFilters) {
      return [];
    }
    return state.quickFilters[type];
  },
);

const myAuctionsNumberListSelector = createDraftSafeSelector(myAuctionsListSelector, (auctions) => {
  return auctions.map((auction) => auction.auction_number);
});

export const myAuctionsSelectors = {
  pagerSelector,
  myAuctionsListSelector,
  myAuctionsQuickFiltersForTypeSelector,
  myAuctionsRawListSelector,
  myAuctionsNumberListSelector,
};
